import type { ReactNode } from "react";
import {
  ActivitiesIcon,
  CarIcon,
  FlightIcon,
  HotelIcon,
  PackageIcon,
  ToursIcon,
} from "./icons";

const TAB_ICON_COMPONENTS: Record<
  string,
  React.FC<{ className?: string; color?: string }>
> = {
  flights: FlightIcon,
  hotels: HotelIcon,
  packages: PackageIcon,
  cars: CarIcon,
  tours: ToursIcon,
  offers: ToursIcon,
  activities: ActivitiesIcon,
};

export function getTabIcon(tabId: string, isActive: boolean): ReactNode | null {
  const IconComponent = TAB_ICON_COMPONENTS[tabId];
  if (!IconComponent) {
    return null;
  }

  return (
    <IconComponent
      className="h-[24px] w-[24px]"
      color={isActive ? "white" : "currentColor"}
    />
  );
}
